// React
import React, { useState, useEffect, useCallback } from "react";

// Kendo
import kendo from "@progress/kendo-ui";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";

// Css
import "./elderBehavior.css"
import styles from "./elderBehavior.module.css"

// Service
import { getUser, isAdmin, isDeveloper, isLogin } from "../../../service/authService";
import { getUserBehaviorList, deleteUserBehavior } from "../../../service/mngt/elderService";

// Component
import { Delete } from "@material-ui/icons";
import ElderBehaviorAdd from './elderBehaviorAdd';
import ElderBehaviorEdit from './elderBehaviorEdit';

const ElderBehavior = ({ conn, elderInfo, setElderInfo }) => {

  const userInfo = getUser();

  const [data, setData] = useState({
    userBehaviorList : [],
  })

  const days = ['월요일', '화요일', '수요일', '목요일', '금요일', '토요일', '일요일'];

  const [dataState, setDataState] = useState({
    userId: elderInfo.dataItem.userId,
    selectedDay: '월요일',
  })


  // 행동패턴 추가 팝업
  const addBehavior = () => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.behaviorAddInfo = true;
      return item;
    });
  }

  // 행동패턴 수정 팝업
  const editBehavior = dataItem => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.behaviorEditInfo = true;
      item.selectedRow = dataItem;
      return item;
    });
  }

  // 닫기 이벤트
  const closeEvt = () => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.behaviorInfo = false;
      return item;
    });
  };

  // 삭제 버튼
  const isDeletedBtn = dataItem => {
    // 삭제 여부 확인
    kendo
    .confirm("행동패턴을 삭제 하시겠습니까?")
    .then(e => {
      deleteUserBehavior(conn, dataItem).then(() => {
        getUserBehaviorList(conn, getUserBehaviorListCallback, getRejection, dataState);
        kendo.alert("행동패턴이 삭제되었습니다.");
      })
    })
    .catch(e => {
      return;
    });
  };


  const getUserBehaviorListCallback = result => {
    setData((data) => {
      const item = { ...data };
      item.userBehaviorList = result;
      return item;
    })

  }

  const getRejection = reject => {
    console.log("getRejection = ", reject);
  };

  useEffect(() => {

    // 조회할 데이터를 가지고 오는 함수를 가정
    getUserBehaviorList(conn, getUserBehaviorListCallback, getRejection, dataState);

  }, [dataState.selectedDay]);

  useEffect(() => {
    // getUserBehaviorList(conn, getUserBehaviorListCallback, getRejection, dataState);
  }, []);

  return (
    <Dialog title={elderInfo.dataItem.userTerm +"님 행동패턴"} onClose={closeEvt}>
      <div>
        {days.map((day, index) => (
            <Button
                key={index}
                onClick={() =>
                  setDataState((dataState) => {
                    const item = { ...dataState };
                    item.selectedDay = day;
                    return item;
                  })
                }
                style={{ fontSize: "20px", marginRight: "10px", marginBottom: "5px", color: dataState.selectedDay === day ? '#fff' : '#686a6d', backgroundColor: dataState.selectedDay === day ? '#7aa6e5' : '#fff' }}
            >
                {day.substring(0, 1)}
            </Button>
        ))}
      </div>
      <div className={styles.behaviorDialog}>
        <Grid 
          className={styles.behaviorList}
          data={data.userBehaviorList}
          onRowClick={editBehavior}
          >         
          <GridNoRecords><img style={{width: "340px", height: "240px"}} src="/images/noData_behavior.png"/></GridNoRecords>
          <GridColumn field="dayofweek" title="요일" width="100px" />
          <GridColumn field="time" title="시간" width="100px" />
          <GridColumn field="residenceStatus" title="재실여부" width="100px" />
          <GridColumn field="behaviorTerm" title="행동" />
          <GridColumn field="behaviorTermOther" title="행동(기타)" />
          <GridColumn title="삭제" filterable={false} sortable={false} width="80px"
            cell={props => (
              <td>
                <a
                  onClick={e => {
                    e.preventDefault();
                    isDeletedBtn(props.dataItem);
                  }}>
                  <i>
                    <Delete />
                  </i>
                </a>
              </td>
            )}
          />
        </Grid>
        <div className={styles.content}>
          <Button onClick={addBehavior}>행동패턴 추가</Button>
          <Button onClick={closeEvt}>닫기</Button>
        </div>
      </div>
      {elderInfo.behaviorAddInfo === true && (
        <ElderBehaviorAdd
          conn={conn}
          elderInfo={elderInfo}
          setElderInfo={setElderInfo}
          getUserBehaviorListCallback={getUserBehaviorListCallback}
          selectedDay={dataState.selectedDay}
        />
      )}
      {elderInfo.behaviorEditInfo === true && (
        <ElderBehaviorEdit
          conn={conn}
          elderInfo={elderInfo}
          setElderInfo={setElderInfo}
          getUserBehaviorListCallback={getUserBehaviorListCallback}
        />
      )}
    </Dialog>
  );
};
export default ElderBehavior;
